
import Sidebar from './Sidebar.vue'
import Profile from './Profile.vue'
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
import BookMostPopularProducts from '../Contents/BookContent/BookMostPopularProducts.vue'
import CourseCategories from '../Contents/BookContent/BookCategories.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    Sidebar,
    Profile,
    InnerPageTitle,
    BookMostPopularProducts,
    CourseCategories,
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapGetters({
      getRedirectUrl: 'getRedirectUrl',
    }),
  },
  props: {
    mini: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    this.loaded = true
  },
}
